import React from 'react';
import { TaskSettings } from '../types/taskSettings';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { instanceToPlain } from 'class-transformer';

export interface TaskSettingsContextProps {
  taskSettings: Map<string, TaskSettings>;
  setTaskSettings: (tasks: Map<string, TaskSettings>) => void;
  taskSettingsLoading: boolean;
}

const defaultContext: TaskSettingsContextProps = {
  taskSettings: new Map(),
  setTaskSettings: () => {},
  taskSettingsLoading: false,
};

export const TaskSettingsContext = React.createContext<TaskSettingsContextProps>(defaultContext);

interface TaskSettingsState {
  items: Record<string, any>[];
  loading: boolean;
}

export const taskSettingsSlice = createSlice({
  name: 'taskSettings',
  initialState: { items: [], loading: true } as TaskSettingsState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    setAll: (state, action: PayloadAction<TaskSettings[]>) => {
      state.items = action.payload.map(p => instanceToPlain(p));
    },
    addAll: (state, action: PayloadAction<TaskSettings[]>) => {
      const map = new Map([...state.items, ...action.payload.map(p => instanceToPlain(p))].map(pmd => [pmd.id, pmd]));
      state.items = [...map.values()];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
